module.exports = __webpack_public_path__ + "assets/bf28241e67511184c14dbd0ef7d39f91.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-700-normal.woff2
// module id = 2637
// module chunks = 121